
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/us/forgot-password",
      function () {
        return require("private-next-pages/us/forgot-password.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/us/forgot-password"])
      });
    }
  